import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./Portfolio.module.css";
import { Button } from "../../Common";
import { bigDecimal } from "js-big-decimal";
import { clearPortfolio, regeneratePortfolio } from "../../api";
import { PortfolioMessages } from "../../Constants/Messages";

function Stock({ stock, custId, refreshPortfolio,featureAccess }) {
  const [message, setMessage] = useState("");
  const [regenerateLoading, setRegenerateLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [activeSymbol, setActiveSymbol] = useState(null);

  const stockColums = [
    "Stock",
    "Name",
    "Avg Price",
    "Total Invested",
    "Units",
    "",
    "",
  ];
  const refreshData = async () => {
    try {
      if (refreshPortfolio) {
        await refreshPortfolio();
      }
    } catch (error) {
      setMessage("Error refreshing portfolio data:", error);
    }
  };
  const regenerateButton = async (symbol) => {
    try {
      setRegenerateLoading(true);
      setActiveSymbol(symbol);
      const response = await regeneratePortfolio(custId, "stock", symbol);

      if (response && response.code === 200) {
        setMessage(PortfolioMessages.ProcessInitiated);
        setTimeout(async () => {
          await refreshData();
          setRegenerateLoading(false);
          setActiveSymbol(null);
          setTimeout(() => setMessage(""), 2000);
        }, 1000);
      } else {
        setMessage(response.data.message);
        setRegenerateLoading(false);
        setActiveSymbol(null);
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      setMessage(PortfolioMessages.RegenerateFailed);
      setRegenerateLoading(false);
      setActiveSymbol(null);
      setTimeout(() => setMessage(""), 3000);
    }
  };
  const clearButton = async (symbol) => {
    try {
      setClearLoading(true);
      setActiveSymbol(symbol);
      const response = await clearPortfolio(custId, "stock", symbol);

      if (response && response.code === 200) {
        setMessage(response.data.results);
        setTimeout(async () => {
          await refreshData();
          setClearLoading(false);
          setActiveSymbol(null);
          setTimeout(() => setMessage(""), 2000);
        }, 1000);
      } else {
        setMessage(response.data.message);
        setClearLoading(false);
        setActiveSymbol(null);
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      setMessage(PortfolioMessages.ClearFailed);
      setClearLoading(false);
      setActiveSymbol(null);
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const calculatePrice = (totalInvestment, units) => {
    if (
      !totalInvestment ||
      !units ||
      totalInvestment === "--" ||
      units === "--"
    ) {
      return "--";
    }
    try {
      const investment = new bigDecimal(totalInvestment);
      const totalUnits = new bigDecimal(units);

      if (totalUnits.getValue() === "0") {
        return "--";
      }

      const price = investment.divide(totalUnits, 2);
      return addCommasInPrice(price.getValue());
    } catch (error) {
    setMessage("Error calculating price:", error);
      return "--";
    }
  };

  const addCommasInPrice = (price, decimal = true) => {
    if (typeof price === "string") {
      const cleanedPrice = price.replace(/[^\d.]/g, "");
      if (!isNaN(cleanedPrice)) {
        return parseFloat(cleanedPrice).toLocaleString("en-US", {
          maximumFractionDigits: decimal ? 2 : 0,
        });
      }
    } else if (!isNaN(price)) {
      return parseFloat(price).toLocaleString("en-US", {
        maximumFractionDigits: decimal ? 2 : 0,
      });
    }
    return price;
  };
  const getPrice = (item) => {
    if (item.averagePrice && item.averagePrice !== "--") {
      return addCommasInPrice(item.averagePrice);
    }
    return calculatePrice(item.totalInvestment, item.totalUnit);
  };

  return (
    <>
      {message && (
        <div
          style={{
            margin: "10px",
            padding: "10px",
            backgroundColor: "#ddffdd",
            borderRadius: "4px",
          }}
        >
          {message}
        </div>
      )}
      <Row style={{ margin: "10px 10px" }}>
        {stockColums.map((item, index) => (
          <Col key={index} className={styles.stockHeading}>
            {item}
          </Col>
        ))}
      </Row>

      {stock.length !== 0 ? (
        stock.map((item, index) => (
          <Row key={index} className={styles.stockRow} style={{ margin: "10px 10px" }}>
            <Col className={styles.stockTitle}>{item.ticker || "--"}</Col>
            <Col className={styles.stockTitle}>
              <span className={styles.stockTitleTruncate} title={item.company}>
                {item.company || "--"}
              </span>
            </Col>
            <Col className={styles.stockTitle}>{getPrice(item)}</Col>
            <Col className={styles.stockTitle}>
              {item.totalInvestment || "--"}
            </Col>
            <Col className={styles.stockTitle}>{item.totalUnit || "--"}</Col>
            <Col>
            {featureAccess?.writeAccess && (
              <Button
                title="Regenerate"
                margin={"0px 10px"}
                onClick={() => regenerateButton(item.symbol)}
                loading={regenerateLoading && activeSymbol === item.symbol}
              />
            )}
            </Col>
            <Col>
            {featureAccess?.writeAccess && (
              <Button
                title="Clear"
                margin={"0px 10px"}
                onClick={() => clearButton(item.symbol)}
                loading={clearLoading && activeSymbol === item.symbol}
              />
            )}
            </Col>
          </Row>
        ))
      ) : (
        <Row style={{ margin: "10px 10px", textAlign: "left", color: "gray" }}>
          <Col colSpan={stockColums.length}>
            <span>No data found</span>
          </Col>
        </Row>
      )}
    </>
  );
}

export default Stock;
